<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent v-loading="allLoading ">
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="title">{{L.effectiveAccount}}</div>
      <!-- DS的客户列表 -->
      <div class="table-wrap" v-if="list.length>0">
        <el-table
          class="cqm-table"
          size="mini"
          :max-height="(list.length>0 && ledList.length>0)?200:400"
          style="width: 100%"
          :data="list"
          @row-click="e=>rowClick(e,1)"
          :row-class-name="e=>rowClassName(e,1)"
        >
          <el-table-column
            align="center"
            prop="customerAccountNo"
            width="70"
           >
            <template slot-scope="scope">
              <span class="iconfont icon-check icon-active" v-show="tableSelect==scope.row.customerAccountNo">&#xe730;</span>
              <span class="iconfont icon-check" v-show="tableSelect!=scope.row.customerAccountNo">&#xe72f;</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            align="left"
            prop="customerName"
            :label="tableLable.DsCustomerName">
          </el-table-column>
          <el-table-column
            align="left"
            prop="customerAccountNo"
            :label="tableLable.DsCustomerAccount">
          </el-table-column>
        </el-table>
      </div>
      <!-- led客户列表 -->
      <div class="table-wrap"  v-if="ledList.length>0">
        <el-table
          class="cqm-table"
          size="mini"
          :max-height="(list.length>0 && ledList.length>0)?200:400"
          style="width: 100%"
          :data="ledList"
          @row-click="e=>rowClick(e,2)"
          :row-class-name="e=>rowClassName(e,2)"
        >
          <el-table-column
            align="center"
            prop="ledCustomerAccountNo"
            width="70">
            <template slot-scope="scope">
              <span class="iconfont icon-check icon-active" v-show="ledTableSelect==scope.row.ledCustomerAccountNo">&#xe730;</span>
              <span class="iconfont icon-check" v-show="ledTableSelect!=scope.row.ledCustomerAccountNo">&#xe72f;</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            align="left"
            prop="ledCustomerAccountName"
            :label="tableLable.LedCustomerName">
          </el-table-column>
          <el-table-column
            align="left"
            prop="ledCustomerAccountNo"
            :label="tableLable.LedCustomerAccount">
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="footer">
        <el-button type="primary" class="btn" @click="handleConfirm">{{L.confirmSelect}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {api_customer_list,api_customer_change} from '@/api/api'
import {postAction} from '@/api/tool'


export default {
  name:'CustomerList',
  data() {
    return {
      show:false,
      tableSelect:'',
      ledTableSelect:'',
      list:[],
      ledList:[],
      tableLable:{
        select:'',
        DsCustomerName:'',
        DsCustomerAccount:'',
        LedCustomerName:'',
        LedCustomerAccount:'',
      } //表格的表头，因为这个地方切换语言的时候没办法正常渲染，所以需要监听语言包的变化，进行重新渲染
    }
  },
  watch:{
    L(newVal){
      this.tableLable=newVal
    }
  },
  methods:{
    rowClassName(e,flag){
      if(flag==1){
        if(this.tableSelect==e.row.customerAccountNo){
          return 'selected-row';
        }
      }
      if(flag==2){
        if(this.ledTableSelect==e.row.ledCustomerAccountNo){
          return 'selected-row';
        }
      }
      return 'common-table-row-class'
    },
    rowClick(row,flag){
      if(flag==1){
        if(this.tableSelect==row.customerAccountNo){
          this.tableSelect=''
        }else{
          this.tableSelect=row.customerAccountNo
        }
      }
      if(flag==2){
        if(this.ledTableSelect==row.ledCustomerAccountNo){
          this.ledTableSelect=''
        }else{
          this.ledTableSelect=row.ledCustomerAccountNo
        }
      }
    },
    /* 获取客户列表 */
    getCustomerList(){
      this.allLoading=true
      postAction(api_customer_list).then(res=>{
        this.allLoading=false
        this.list=res.dsCustomerList
        this.ledList=res.ledCustomerList
        this.tableSelect=this.$store.state.userInfo.customerAccountNo
        this.ledTableSelect=this.$store.state.userInfo.ledCustomerAccountNo
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 确认选择 */
    handleConfirm(){
      if(!this.tableSelect && !this.ledTableSelect){
        this.$message({
          message: this.tableLable.selectOne,
          type: 'warning'
        })
        return
      }
      let params = {
        dsCustomerAccountNo:this.tableSelect,
        ledCustomerAccountNo:this.ledTableSelect
      }
      this.allLoading=true
      postAction(api_customer_change,params).then(()=>{
        this.allLoading=false
        this.goCatalogue()
        this.$router.go(0)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    open(){
      this.show=true
      this.getCustomerList()
    },
    close(){
      this.show=false
    }
  },
  mounted(){
    this.tableLable=this.L
  }
}
</script>

<style lang="less">
/* 这个是表格部分的css，所以要单独给个style的标签，放在scoped里面不生效的 */
.common-table-row-class{
  &:hover{
    cursor: pointer;
  }
}
.selected-row{
  background-color: #fff0e6 !important;
}
</style>

<style lang="less" scoped>
@import url('../../public/css/public.less');
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    // background-color: red;
    border-radius: 4px;
    position: absolute;
    // &:extend(.main-box-shadow);
    width:800px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    padding:20px 40px;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      // background-color: red;
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .title{
      font-size: 16px;
      font-weight: 600;
    }
    .table-wrap{
      margin-top: 20px;
      .icon-check{
        font-size: 19px;
        color:#ccc;
        &:hover{
          cursor: pointer;
        }
      }
      .icon-active{
        color:@mainColor;
      }
    }
    .footer{
      width:100%;
      margin-top:30px;
      .btn{
        white-space:pre-wrap;
        overflow: auto;
        width:100%;
      }
    }
  }
}

</style>